import React from 'react';
import { Link, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';
import { getItemById } from '../lib/util';
import './MegaMenuChildren.css';

const MegaMenuChildren = (props) => {
  const {
    structure, categories, location, match, toggleSearch,
  } = props;
  const activeCategoryId = match.params.id;
  const handleClick = (event) => {
    toggleSearch({
      closeOnly: true,
    });
    event.stopPropagation();
  };
  let activeCategory = {
    children: [],
  };
  for (let i = 0; i < structure.length; i += 1) {
    if (structure[i].id === activeCategoryId * 1) {
      activeCategory = structure[i];
      break;
    }
  }
  if (activeCategory.children.length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <div className="column">
        {activeCategory.children.map((elem) => {
          
          if (elem.product) {
            let chineseTitle = "";
            if(elem.product.chinese_title){
              chineseTitle = " " + elem.product.chinese_title;
            }

            return (
              <Link
                key={elem.product.name}
                className="navbar-item"
                to={`/product/${elem.product.product_ID}`}
                onClick={handleClick}
              >
                <div className="navbar-content">
                  <span className="product">{`${elem.product.title}${chineseTitle}`}</span>
                </div>
              </Link>
            );
          }
          const category = getItemById({
            array: categories,
            id: elem.id,
            key: 'category_ID',
          });
          const linkToPath = `${match.url}/${elem.id}`;
          return (
            <Link
              key={`menu${elem.id}`}
              className={`navbar-item ${
                location.pathname.indexOf(linkToPath) !== -1 ? 'is-active' : ''
              }`}
              to={linkToPath}
              onClick={handleClick}
            >
              <div className="navbar-content">
                <FontAwesomeIcon
                  className={classnames({
                    icon: true
                  })}
                  icon={faAngleRight}
                />
                <span className="category">{category.title}</span>
              </div>
            </Link>
          );
        })}
      </div>
      <div className="columns catalogDropdown-columns">
        <Route
          path={`${match.url}/:id`}
          render={properties => (
            <MegaMenuChildren
              structure={activeCategory.children}
              categories={categories}
              toggleSearch={toggleSearch}
              {...properties}
            />
          )}
        />
      </div>
    </React.Fragment>
  );
};

MegaMenuChildren.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
  structure: PropTypes.arrayOf(PropTypes.object).isRequired,
  toggleSearch: PropTypes.func.isRequired,
};

MegaMenuChildren.defaultProps = {
  match: {
    params: {
      id: '1',
    },
  },
  location: {
    pathname: '/catalog',
  },
};

export default MegaMenuChildren;



// WEBPACK FOOTER //
// ./src/components/MegaMenuChildren.js